import { useState, useEffect } from 'react';
import CityPickerModal from './CityPickerModal';

export default function StickyNav() {
  const [scrolled, setScrolled] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToCategories = () => {
    document.getElementById('kategoriler')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled
            ? 'bg-[#0a0a0f]/95 backdrop-blur-xl border-b border-white/10'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between">
          {/* Logo */}
          <a href="/" className="flex items-center gap-3 cursor-pointer">
            <img
              src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/b2f114d182001bcdb417b0f3094f16f5.jpeg"
              alt="Kampanya Kupon"
              className="h-9 w-auto rounded-lg"
            />
            <span
              className="text-white font-bold text-lg tracking-tight hidden sm:block"
              style={{ fontFamily: "'Space Grotesk', sans-serif" }}
            >
              Kampanya<span className="text-purple-400">Kupon</span>
            </span>
          </a>

          {/* Nav Links */}
          <div className="hidden md:flex items-center gap-6 text-sm text-gray-400">
            <button
              onClick={scrollToCategories}
              className="hover:text-white transition-colors cursor-pointer whitespace-nowrap"
            >
              Kategoriler
            </button>
            <a href="#nasil-calisir" className="hover:text-white transition-colors whitespace-nowrap">
              Nasıl Çalışır?
            </a>
            <a href="#hakkinda" className="hover:text-white transition-colors whitespace-nowrap">
              Hakkında
            </a>
          </div>

          {/* CTA */}
          <button
            onClick={() => setModalOpen(true)}
            className="hidden sm:flex items-center gap-2 bg-green-500 hover:bg-green-400 text-black font-semibold text-sm px-4 py-2 rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{ boxShadow: '0 0 20px rgba(34, 197, 94, 0.3)' }}
          >
            <i className="ri-whatsapp-line text-base" />
            WhatsApp&apos;a Bağlan
          </button>
        </div>
      </nav>

      {modalOpen && (
        <CityPickerModal
          categoryName="Kampanya Kupon"
          section="sticky_nav"
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  );
}
